import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { BenefitsStrip } from '../components/BenefitsStrip';
import { HowItWorks } from '../components/HowItWorks';
import { StatsStrip } from '../components/StatsStrip';
import { PrivacySection } from '../components/PrivacySection';
import { TaglineSection } from '../components/TaglineSection';
import { CTASection } from '../components/CTASection';
export function Home() {
  return <>
      <HeroSection data-id="element-262" />
      <BenefitsStrip data-id="element-263" />
      <HowItWorks data-id="element-264" />
      <StatsStrip data-id="element-265" />
      <PrivacySection data-id="element-266" />
      <TaglineSection data-id="element-267" />
      <CTASection data-id="element-268" />
    </>;
}